<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        router-name="/settlement/payee-manage">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getPayeeList"
                    ref="table"
                    router-name="/settlement/payee-manage">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowErrorMessage, ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { getTodayParams } from '@/utils/tools/time';
import PayeeManageService from '@/views/settlement/api/settlement-payee';
import { GenderStatus, PayeeStatus } from '@/views/settlement/payee-manage/status/payee';
import { unsubscrible } from '@/views/subscription/api/subscription';

export default {
  components: {
    SearchComponent,
    CustomTable,
    CustomMessage,
  },
  data() {
    return {
      getTodayParams,
      ...PayeeManageService,
      isAuthentication: false,
      searchCondition: [
        {
          key: 'bankName',
          name: 'message.payee.bankName',
          type: 'input',
          defValue: '',
        },
      ],
      searchButtonList: [
        {
          type: 'none',
          permissionCode: 'settlement:payee:add',
          name: 'message.payee.addPayee',
          func: (params) => {
            if (this.isAuthentication) {
              this.$router.push({ path: '/settlement/payee-manage/add' });
            } else {
              ShowWarningMessage(this.$t('message.payee.canAddedAgain'));
            }
          },
        }],
      tableCondition: [
        { // 序号
          titleBar: { type: 'text', title: 'message.tableCommon.serialNumber' },
          key: 'id',
          type: 'serialNumber',
          itemWidth: 100,
        },
        { // 姓名
          titleBar: { type: 'text', title: 'message.transaction.name' },
          key: 'name',
          type: 'text',
        },
        { // 默认
          titleBar: { type: 'text', title: '' },
          key: 'defaultCard',
          type: 'text',
          isInternationalization: true,
          itemWidth: 75,
          textFunc: () => 'message.tableCommon.default',
          itemStyle: (row) => {
            if (row.defaultCard) {
              return { display: 'inline-block' };
            } else {
              return { display: 'none' };
            }
          },
        },
        { // 证件号码
          titleBar: { type: 'text', title: 'message.payee.identificationNumber' },
          key: 'idNumber',
          type: 'text',
        },
        { // 性别
          titleBar: { type: 'text', title: 'message.payee.gender' },
          key: 'gender',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => getEnantiomericValue(GenderStatus, data.gender),
        },
        { // 银行名称
          titleBar: { type: 'text', title: 'message.payee.bankName' },
          key: 'bankName',
          type: 'text',
        },
        { // 银行账号
          titleBar: { type: 'text', title: 'message.payee.cardNumber' },
          key: 'cardNumber',
          type: 'text',
        },
        { // 创建时间
          titleBar: { type: 'text', title: 'message.payee.creationTime' },
          key: 'createTime',
          type: 'text',
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => getEnantiomericValue(PayeeStatus, data.status),
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'text' },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              permissionCode: 'settlement:payee:view',
              func: (data) => {
                this.$router.push({ path: '/settlement/payee-manage/view', query: { cardInfoId: data.cardInfoId } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.edit',
              permissionCode: 'settlement:payee:edit',
              isDisplayFunc: (data) => data.status === 'F',
              func: (data) => {
                this.$router.push({ path: '/settlement/payee-manage/edit', query: { cardInfoId: data.cardInfoId } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.makeDefault',
              permissionCode: 'settlement:payee:default',
              isDisplayFunc: (data) => !data.defaultCard && data.status === 'S',
              func: (data) => {
                this.$refs.customMessage.openHttpModal({
                  contentHtml: `${this.$t('message.payee.makeItDefault')}?`,
                  httpFunction: this.postDefaultCard,
                  params: { cardInfoId: data.cardInfoId },
                  successFunction: this.onRefreshTable,
                });
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    onRefreshTable() {
      return this.$refs.table.refreshTable();
    },
  },
  mounted() {
    this.getPayeeVerifyInfo().then((data) => {
      this.searchButtonList[0].type = 'add';
      if (data && data.status) {
        this.isAuthentication = (data.status + '') === 'S' || (data.status + '') === 'N';
      }
    }).catch(() => {
    });
  },
  created() {
  },
};
</script>
<style lang="scss">
#refundDetail .is-bordered-label {
  width: 50%;
}
</style>
